<template>
  <div id="app" class="w-full overflow-hidden">
    <Loading :active="isLoading"></Loading>
    <router-view v-if="isLoginReady"></router-view>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import allJs from '@/components/all.js'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'app',
    components: {
      Loading
    },
    data () {
      return {
        isLoginReady: false
      }
    },
    mixins: [
      allJs
    ],
    metaInfo: {
      title: '',
      titleTemplate: '%s · AI英語學習教室'
    },

    computed: {
      ...mapGetters([
        'isLoading',
        'authorized'
      ])
    },
    beforeMount () {
      this.initLogin()
    },
    mounted () {
    },
    beforeDestroy () {
      if (this.authorized && localStorage.getItem('ai_uuid')) {
        this.$store.dispatch('logout')
      }
    },

    methods: {
      ...mapActions({
        dologinETA: 'loginETA',
        dologinSCHOOL: 'loginSchool',
        doGetRemainPoints: 'getRemainPoints'
      }),

      initLogin () {
        this.$router.onReady(async () => {
          const ai_sid = localStorage.getItem('ai_sid') || ''
          const ai_uuid = localStorage.getItem('ai_uuid') || ''
          const token = localStorage.getItem('authorizedAIToken') || ''
          const { sid, s, token: queryToken, uuid, expired_time } = this.$route.query

          this.$store.dispatch('isLoading', true)

          try {
            if (sid) {
              if (s) {
                localStorage.setItem('s', s)
              } else {
                localStorage.removeItem('s')
              }

              await this.initAieta()
            } else if (queryToken && uuid && expired_time) {
              await this.initSchool()
            } else if (token && !ai_sid && !ai_uuid) {
              await this.webLogin()
            } else if (!this.authorized) {
              if (this.$route.name !== 'login') {
                await this.$router.replace({ name: 'login' })
              }
            } else {
              await this.$store.dispatch('refreshPageLogin')
            }
          } finally {
            this.isLoginReady = true
            this.$store.dispatch('isLoading', false)
          }
        })
      },

      initSchool () {
        // school登入
        this.$store.commit('LOGOUT')
        localStorage.getItem('authorizedAIToken') ? localStorage.removeItem('authorizedAIToken') : null
        localStorage.getItem('ai_sid') ? localStorage.removeItem('ai_sid') : null

        return this.dologinSCHOOL({ token: this.$route.query.token, uuid: this.$route.query.uuid, uuid_expired_time: this.$route.query.expired_time })
      },

      initAieta () {
        // 研三登入
        let sid = this.$route.query.sid
        let s = this.$route.query.s || null

        this.$store.commit('LOGOUT')
        localStorage.getItem('authorizedAIToken') ? localStorage.removeItem('authorizedAIToken') : null
        localStorage.setItem('ai_sid', sid)

        localStorage.getItem('ai_uuid') ? localStorage.removeItem('ai_uuid') : null
        localStorage.getItem('uuid_expired_time') ? localStorage.removeItem('uuid_expired_time') : null

        return this.dologinETA({ sid, s })
      },

      webLogin () {
        this.$store.commit('LOGIN', { sid: '', uuid: '' })

        localStorage.getItem('ai_sid') ? localStorage.removeItem('ai_sid') : null
        localStorage.getItem('ai_uuid') ? localStorage.removeItem('ai_uuid') : null
        localStorage.getItem('uuid_expired_time') ? localStorage.removeItem('uuid_expired_time') : null

        return this.doGetRemainPoints()
      }
    }
  }
</script>

<style>
#app {
  min-height: 100vh;
  width: 100vw;
}
</style>
